const routes = {
  reservations: 'Bestellungen',
};

export default routes;
